import React from 'react';
import * as fmt from '../../lib/format';

interface Props {
  label: string;
  count?: number;
  selected: boolean;
  onClick: () => void;
  title?: string;
}

// A pill that doubles as a filter toggle. Feedback starts on press.
export default function FilterChip({ label, count, selected, onClick, title }: Props) {
  return (
    <button
      type="button"
      aria-pressed={selected}
      title={title}
      onClick={onClick}
      className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-medium ring-1 ring-inset transition-[transform,background-color,box-shadow] duration-150 ease-out active:scale-[0.97] motion-reduce:transition-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 ${
        selected ? 'bg-blue-50 text-blue-800 ring-blue-500' : 'bg-white text-gray-700 ring-gray-200 hover:ring-gray-300 contrast-more:ring-gray-400'
      }`}
    >
      {label}
      {count !== undefined && <span className="font-semibold tabular-nums">{fmt.count(count)}</span>}
    </button>
  );
}
